import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';

export const useGetCurrentNightAudit = () => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_CURRENT_NIGHT_AUDIT],
    queryFn: API.nightAudit.getCurrentNightAudit
  });

  return {
    data,
    status,
    isLoading,
    isFetching
  };
};
